<icz-essl-object-detail
  [waiting]="loadingService.isLoading(this)"
  [objectNameGeneratorFn]="fileNameGeneratorFn"
  [baseUrlPrefixParts]="baseUrlPrefixParts"
>
  <icz-file-detail-toolbar
    toolbar
    [waiting]="loadingService.isLoading(fileDetailService)"
    [blockingOverlayOpts]="{spinnerDiameter: 40}"
    [runningActivity]="fileDetailService.runningActivity$ | async"
    [refActivity]="fileDetailService.refActivity$ | async"
    [refTask]="fileDetailService.refTask$ | async"
    [isRegistryOfficeTransferActivityView]="(fileDetailService.isRegistryOfficeTransferActivityView$ | async)!"
  ></icz-file-detail-toolbar>
  <router-outlet class="router-outlet-block-container"></router-outlet>
</icz-essl-object-detail>
